import moment, {Moment} from 'moment';
import mtz from 'moment-timezone';
import {DateRange} from '../stores/TimeIntervalStore';

export class DateUtils {
    public static formatDateRange(startDate?: moment.Moment, endDate?: moment.Moment): string {
        if (startDate === undefined || endDate === undefined) {
            console.warn('startDate === undefined || endDate === undefined');
            return '';
        }

        const endDateClone = endDate.clone();

        const endDateStr: string = endDateClone.format('l');

        if (startDate.isSame(endDateClone, 'days')) {
            return endDateStr;
        }

        let dateStr: string;

        if (startDate.locale() === 'de') {
            dateStr = startDate.date().toString() + '.';
            if (startDate.month() !== endDateClone.month() || startDate.year() !== endDateClone.year()) {
                dateStr += startDate.month() + 1 + '.';
            }
            if (startDate.year() !== endDateClone.year()) {
                dateStr += startDate.year();
            }
        } else {
            dateStr = startDate.format('l');
        }

        return dateStr + ' - ' + endDateStr;
    }

    public static getDateRangeInDays(startDate?: moment.Moment, endDate?: moment.Moment): number {
        if (startDate !== undefined && endDate !== undefined) {
            return endDate.diff(startDate, 'days') + 1;
        }
        return 0;
    }

    public static getTimeDifferenceBetweenDates(startDate: moment.Moment, endDate: moment.Moment): string {
        const duration = moment.duration(startDate.diff(endDate));
        return duration.format('dd:hh:mm:ss', {stopTrim: 'm'});
    }

    public static getDayMonthFormat(): string {
        return 'DD.MM';
    }

    public static dateIsSame(a?: moment.Moment, b?: moment.Moment, resultIfBothUndefined = false): boolean {
        if (a === undefined || b === undefined) {
            return resultIfBothUndefined;
        }
        return a.isSame(b);
    }

    public static copyDateRange(dateRange: DateRange) {
        return {
            startDate: moment(dateRange.startDate),
            endDate: moment(dateRange.endDate),
        };
    }

    public static dateRangeIsSame(firstDateRange: DateRange, secondDateRange: DateRange): boolean {
        return (
            this.dateIsSame(firstDateRange.startDate, secondDateRange.startDate, true) &&
            this.dateIsSame(firstDateRange.endDate, secondDateRange.endDate, true)
        );
    }

    public static isDateRange = (value: any): value is {startDate: moment.Moment; endDate: moment.Moment} => {
        return value && moment.isMoment(value.startDate) && moment.isMoment(value.endDate);
    };

    public static toHourlyDateRange(dateRange: DateRange): DateRange {
        if (!dateRange.startDate || !dateRange.endDate) {
            throw Error();
        }

        return {
            startDate: moment(dateRange.startDate),
            endDate: moment(dateRange.endDate).add(1, 'seconds'),
        };
    }

    // tslint:disable-next-line:no-identical-functions
    public static toDailyDateRange(dateRange: DateRange): DateRange {
        if (!dateRange.startDate || !dateRange.endDate) {
            throw Error();
        }

        return {
            startDate: moment(dateRange.startDate),
            endDate: moment(dateRange.endDate).add(1, 'days'),
        };
    }

    public static withLocalTimeZone(momentDate?: Moment): Moment {
        return momentDate ? mtz(momentDate).tz(mtz.tz.guess()) : mtz().tz(mtz.tz.guess());
    }

    public static normalizeDateRange(dateRange: DateRange): DateRange {
        return {
            startDate: dateRange.startDate ? moment(dateRange.startDate.startOf('day')) : undefined,
            endDate: dateRange.endDate ? moment(dateRange.endDate.endOf('day')) : undefined,
        };
    }
}



// WEBPACK FOOTER //
// ./src/utility/DateUtils.ts